import styled, { keyframes, css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';
import { isGlobetrotter } from '../../utils/theming.js';
import Icon from '../Icon/Icon.js';

// @ts-nocheck
var slideRightToLeft = keyframes(["from{transform:translateX(100%);}to{transform:translateX(0%);}"]);
var Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-tvn50t-0"
})(["display:none;background:var(--color-white);position:relative;", " ", " ", ""], mq.sMax(css(["background:var(--color-white);height:100%;"])), mq.s(css(["padding:0.8rem 0;box-shadow:0px 2px 26px 0px rgba(0,0,0,0.12);width:28.8rem;"])), function (_ref) {
  var $show = _ref.$show;
  return $show && css(["", " ", ""], mq.sMax(css(["display:flex;flex-direction:column;"])), mq.s(css(["display:block;"])));
});
var Main = styled.div.withConfig({
  displayName: "style__Main",
  componentId: "sc-tvn50t-1"
})(["", ""], mq.sMax(css(["display:flex;flex-direction:column;flex:1 1 auto;overflow-y:auto;overflow-x:hidden;scrollbar-width:none;&::-webkit-scrollbar{width:0;}"])));
var Heading = styled.h2.withConfig({
  displayName: "style__Heading",
  componentId: "sc-tvn50t-2"
})(["", " ", " ", ""], mq.sMax(css(["font:var(--font-headline-s);line-height:1.3;color:var(--color-text);padding:0 16px;margin-bottom:2rem;"])), mq.s(css(["display:none;"])), function (_ref2) {
  var $hide = _ref2.$hide;
  return $hide && css(["", ""], mq.sMax(css(["display:none;"])));
});
var Footer = styled.div.withConfig({
  displayName: "style__Footer",
  componentId: "sc-tvn50t-3"
})(["width:100%;box-shadow:0px 0px 31.4px 0px rgba(0,0,0,0);transition:box-shadow 0.6s;position:relative;z-index:10;", ""], function (_ref3) {
  var $overflow = _ref3.$overflow;
  return $overflow && css(["box-shadow:0px 0px 31.4px 0px rgba(0,0,0,0.12);"]);
});
var MenuItemWrapper = styled.li.withConfig({
  displayName: "style__MenuItemWrapper",
  componentId: "sc-tvn50t-4"
})(["position:relative;display:block;background:", ";@media (hover:hover){&:hover{background:", ";}}", " ", " ", ""], function (_ref4) {
  var $active = _ref4.$active;
  return $active ? 'var(--color-quartz-200)' : 'none';
}, function (_ref5) {
  var $active = _ref5.$active;
  return !$active ? 'var(--color-quartz-50)' : 'var(--color-quartz-200)';
}, function (_ref6) {
  var $active = _ref6.$active,
    $hasChildren = _ref6.$hasChildren;
  return $active && $hasChildren && mq.sMax(css(["display:contents;"]));
}, function (_ref7) {
  var $hidden = _ref7.$hidden;
  return $hidden && mq.sMax(css(["display:none;"]));
}, function (_ref8) {
  var $alignContentToItem = _ref8.$alignContentToItem;
  return !$alignContentToItem && mq.s(css(["position:unset;"]));
});
var MenuItemButton = styled.button.withConfig({
  displayName: "style__MenuItemButton",
  componentId: "sc-tvn50t-5"
})(["font:var(--font-body-m);color:var(--color-text-subtle);padding:1.2rem 16px;line-height:1.35;display:flex;align-items:center;justify-content:space-between;width:100%;text-align:left;", " ", ""], function (_ref9) {
  var $active = _ref9.$active;
  return $active && mq.sMax(css(["display:none;"]));
}, mq.s(css(["color:var(--color-text);"])));
var MenuItemButtonArrow = styled(Icon).withConfig({
  displayName: "style__MenuItemButtonArrow",
  componentId: "sc-tvn50t-6"
})(["transition:transform 0.2s;transform:", ";"], function (_ref10) {
  var $active = _ref10.$active;
  return $active ? 'rotate(180deg)' : 'none';
});
var MenuItemContent = styled.div.withConfig({
  displayName: "style__MenuItemContent",
  componentId: "sc-tvn50t-7"
})(["display:", ";background:var(--color-white);", " ", " ", ""], function (_ref11) {
  var $active = _ref11.$active;
  return $active ? 'block' : 'none';
}, mq.sMax(css(["width:100vw;padding:0 16px;"])), mq.s(css(["min-width:100%;max-height:560px;overflow-y:auto;position:absolute;top:0;left:calc(100% + 0.8rem);padding:2.4rem;box-shadow:0px 2px 26px 0px rgba(0,0,0,0.12);scrollbar-width:thin;", ""], isGlobetrotter(css(["scrollbar-color:var(--color-almostblack) var(--color-white);"])))), function (_ref12) {
  var $active = _ref12.$active;
  return $active && mq.sMax(css(["display:block;animation-name:", ";animation-duration:0.3s;"], slideRightToLeft));
});
var MenuItemCloseButton = styled.button.withConfig({
  displayName: "style__MenuItemCloseButton",
  componentId: "sc-tvn50t-8"
})(["padding:0.6rem 1.7rem 0.6rem 1rem;position:absolute;left:-1rem;top:0;"]);
var MenuItemBackArrow = styled(Icon).withConfig({
  displayName: "style__MenuItemBackArrow",
  componentId: "sc-tvn50t-9"
})(["transform:rotate(180deg);"]);
var MenuItemContentHeader = styled.div.withConfig({
  displayName: "style__MenuItemContentHeader",
  componentId: "sc-tvn50t-10"
})(["", " ", ""], mq.sMax(css(["display:flex;align-items:center;margin-bottom:2rem;position:relative;"])), mq.s(css(["display:none;"])));
var MenuItemHeading = styled.h3.withConfig({
  displayName: "style__MenuItemHeading",
  componentId: "sc-tvn50t-11"
})(["", " ", ""], mq.sMax(css(["font:var(--font-headline-s);line-height:1.3;color:var(--color-text);margin-left:3rem;"])), mq.s(css(["display:none;"])));

export { Footer, Heading, Main, MenuItemBackArrow, MenuItemButton, MenuItemButtonArrow, MenuItemCloseButton, MenuItemContent, MenuItemContentHeader, MenuItemHeading, MenuItemWrapper, Wrapper };
//# sourceMappingURL=style.js.map
